import { mapCurrencyCodeToSymbol } from 'app/core/api/product-assignment/api-product-assignment.types';
import {
  ChatActionData,
  ChatEventType,
  CurrencyObject,
  quotingMsgTypes,
} from 'app/core/api/repairer/api-repairer.types';
import { MissingItemError } from 'app/core/errors/error-variants';
import { isInArray } from 'app/tools/general.types';

type MessageInputDetails = {
  quotationAmount?: CurrencyObject;
  eventType: ChatEventType;
};

export type FullMessageDetails = {
  messageText: string;
  actionData: ChatActionData;
};

const quoteAgreedMsgTypes = [
  ChatEventType.DIAGNOSIS_QUOTE_AGREED,
  ChatEventType.REPAIR_QUOTE_AGREED,
] as const;

const quoteAgreedMsg = 'Yes, okay';

export const getFullMessageDetails = ({
  quotationAmount,
  eventType,
}: MessageInputDetails): FullMessageDetails => {
  let messageText = '';

  const actionData: ChatActionData = {};

  if (isInArray(eventType, quotingMsgTypes)) {
    if (!quotationAmount) throw new MissingItemError('quotation');

    const isDiagnosis = eventType === ChatEventType.DIAGNOSIS_QUOTE;
    const serviceType = isDiagnosis ? 'diagnostics' : 'repair';
    const { amount, currency } = quotationAmount;

    messageText = `The price for ${serviceType} will be ${
      mapCurrencyCodeToSymbol.get(currency) || ''
    }${amount}. Are you happy to proceed?`;
    actionData.quotationAmount = { currency, amount };
  } else if (isInArray(eventType, quoteAgreedMsgTypes)) {
    messageText = quoteAgreedMsg;
  }
  return { messageText, actionData };
};

type GetButtonTextInputs = {
  eventType: ChatEventType;
  displayText: string;
};
export const getButtonText = ({
  eventType,
  displayText,
}: GetButtonTextInputs): string => {
  if (isInArray(eventType, quotingMsgTypes)) {
    return `Issue ${displayText.toLowerCase()}`;
  }
  if (isInArray(eventType, quoteAgreedMsgTypes)) {
    return `${quoteAgreedMsg} (agree to quote)`;
  }
  if (eventType === ChatEventType.REPAIR_COMPLETED) {
    return 'Complete repair';
  }
  return displayText;
};
